import { useRouter } from "@tanstack/react-router";
import { useState } from "react";

import { vConsole } from "@/debug/vConsole";

import { DevToolsMenu } from "./DevToolsMenu";
import { DevToolsTrigger } from "./DevToolsTrigger";
import { TanstackQueryDevtools } from "./tools/TanstackQueryDevtools";
import { TanstackRouterDevtools } from "./tools/TanstackRouterDevtools";
import { usePurchaseBlock } from "./tools/usePurchaseBlock";

export type ActivePanel = "rq" | "router" | "console" | null;

export function DevToolsHub() {
  const router = useRouter();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [activePanel, setActivePanel] = useState<ActivePanel>(null);

  const purchaseBlock = usePurchaseBlock();

  const togglePanel = (panel: NonNullable<ActivePanel>) => {
    setAnchorEl(null);

    setActivePanel((prev) => {
      const nextPanel = prev === panel ? null : panel;

      if (vConsole) {
        if (nextPanel === "console") vConsole.show();
        if (prev === "console") vConsole.hide();
      }

      return nextPanel;
    });
  };

  return (
    <div dir="ltr">
      <div>
        <TanstackQueryDevtools isOpen={activePanel === "rq"} />
        <TanstackRouterDevtools
          router={router}
          isOpen={activePanel === "router"}
        />
      </div>

      <DevToolsTrigger
        isOpen={Boolean(anchorEl) || Boolean(activePanel)}
        onClick={(e) => {
          if (activePanel) {
            if (activePanel === "console" && !!vConsole) vConsole.hide();

            setActivePanel(null);
          }

          setAnchorEl((prev) => (prev ? null : e.currentTarget));
        }}
        purchaseBlock={purchaseBlock}
      />

      <DevToolsMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        activePanel={activePanel}
        onTogglePanel={togglePanel}
        purchaseBlock={purchaseBlock}
      />
    </div>
  );
}
